export default __webpack_public_path__ + "static/media/data.740d9cfe.svg";